/* © CNES */
import { QueryFunctionContext } from '@tanstack/react-query';
import { apiConfiguration } from '../APIConfiguration';
import { handleHttpError } from '../common';

/**
 * Launch the feedback service.
 * @param queryKey the query parameters.
 * @returns a Promise that will return a 200 status if the service has succeeded
 */
export const sendFeedback = async ({
  queryKey,
}: QueryFunctionContext<any>): Promise<any> => {
  let res: Response | undefined;
  const [, launchParams, navigate, setError400] = queryKey;

  if (process.env.NODE_ENV === 'production') {
    res = await fetch(`${apiConfiguration.apiBaseUrl}/feedback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Prefer: 'respond-async',
      },
      body: JSON.stringify(launchParams).replaceAll('\\', ''),
    });
    handleHttpError(res, navigate, setError400);
  } else {
    res = new Response(JSON.stringify({ test: 'OK' }));
  }
  return res?.json();
};
